// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RegisterPage_wrapper__3chlD","loginCta":"RegisterPage_loginCta__3rRFs","ctaLink":"RegisterPage_ctaLink__2tvIs","content":"RegisterPage_content__2W9c_"};